  import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
  import { Router } from '@angular/router';
  import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'; 

@Component({
  selector: 'app-dashboard-popup',
  templateUrl: './dashboard-popup.html',
  styleUrls: ['./dashboard-popup.css']
})
export class DashboardPopupComponent implements OnChanges {

  modalRef: BsModalRef; 
  @Input() isSubmitEnabled;
  @Output() callSubmit: EventEmitter<any> = new EventEmitter();
  enableSubmitButton: any;
  constructor(private _router:Router, private modalService: BsModalService) { }

  ngOnChanges(changes: SimpleChanges): void {
    for (let property in changes) {
      if (property === 'isSubmitEnabled') {
this.enableSubmitButton = changes[property].currentValue;
       
      } 
  }
  }
  
  openDashboardPopup(template: TemplateRef<any>) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-lg' })
      );
   
  }
  gotoDashboard() {
    this.modalRef.hide();
    this.callSubmit.emit(true);
    this._router.navigate(['/dashboard']);
  }
  closeDashboardPopup() {
    this.modalRef.hide();
  }
}
